// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WEpg6{display:flex;flex-direction:column;list-style:none;padding:0;margin:0}.FDdMM{gap:4px}.EeeiF{gap:8px}.PI0BQ{gap:12px}.cyTGw{display:flex;flex-direction:row;align-items:center}.cyTGw.em0u6{align-items:flex-start}.cyTGw.em0u6 .tmDFl{margin-top:calc((var(--bullet-first-line-height) - 4px)/2)}.cyTGw.em0u6 .yoKyK{margin-top:calc((var(--bullet-first-line-height) - 6px)/2)}.cyTGw.em0u6 .jcWlb{margin-top:calc((var(--bullet-first-line-height) - 8px)/2)}.cyTGw.em0u6 .bhKlR{margin-top:calc((var(--bullet-first-line-height) - 2px)/2)}.cM9DE{--bullet-first-line-height: var(--line-height-h1, 56px)}.QVPnc{--bullet-first-line-height: var(--line-height-h2, 52px)}.th2U_{--bullet-first-line-height: var(--line-height-h3, 36px)}.FtKKc{--bullet-first-line-height: var(--line-height-h4, 34px)}.ZHjke{--bullet-first-line-height: var(--line-height-h5, 32px)}.Cr7eo{--bullet-first-line-height: var(--line-height-h6, 30px)}.e0J7Z{--bullet-first-line-height: var(--line-height-p1, 22px)}.DLl7v{--bullet-first-line-height: var(--line-height-p2, 16px)}.G9mLZ{--bullet-first-line-height: var(--line-height-p3, 14px)}.YQfT7{display:inline-block;flex-shrink:0}.tmDFl{width:4px;height:4px}.yoKyK{width:6px;height:6px}.jcWlb{width:8px;height:8px}.ZRlT9{background-color:currentColor;border-radius:50%}.oIrZ1{border:1.5px solid currentColor;border-radius:50%;background:transparent}.NzjmS{background-color:currentColor;border-radius:0}.bhKlR{background-color:currentColor;border-radius:0;width:8px;height:2px}.zJNaE{margin-right:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 40px)`,
	"fontSizeH2": `var(--font-size-h2, 36px)`,
	"fontSizeH3": `var(--font-size-h3, 28px)`,
	"fontSizeH4": `var(--font-size-h4, 24px)`,
	"fontSizeH5": `var(--font-size-h5, 20px)`,
	"fontSizeH6": `var(--font-size-h6, 18px)`,
	"fontSizeP1": `var(--font-size-p1, 14px)`,
	"fontSizeP2": `var(--font-size-p2, 12px)`,
	"fontSizeP3": `var(--font-size-p3, 10px)`,
	"lineHeightH1": `var(--line-height-h1, 56px)`,
	"lineHeightH2": `var(--line-height-h2, 52px)`,
	"lineHeightH3": `var(--line-height-h3, 36px)`,
	"lineHeightH4": `var(--line-height-h4, 34px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 30px)`,
	"lineHeightP1": `var(--line-height-p1, 22px)`,
	"lineHeightP2": `var(--line-height-p2, 16px)`,
	"lineHeightP3": `var(--line-height-p3, 14px)`,
	"root": `WEpg6`,
	"compact": `FDdMM`,
	"default": `EeeiF`,
	"relaxed": `PI0BQ`,
	"item": `cyTGw`,
	"itemBulletOnFirstLine": `em0u6`,
	"bulletSmall": `tmDFl`,
	"bulletDefault": `yoKyK`,
	"bulletLarge": `jcWlb`,
	"dash": `bhKlR`,
	"firstLineH1": `cM9DE`,
	"firstLineH2": `QVPnc`,
	"firstLineH3": `th2U_`,
	"firstLineH4": `FtKKc`,
	"firstLineH5": `ZHjke`,
	"firstLineH6": `Cr7eo`,
	"firstLineParagraph1": `e0J7Z`,
	"firstLineParagraph2": `DLl7v`,
	"firstLineParagraph3": `G9mLZ`,
	"bullet": `YQfT7`,
	"disc": `ZRlT9`,
	"circle": `oIrZ1`,
	"square": `NzjmS`,
	"bulletMargin": `zJNaE`
};
export default ___CSS_LOADER_EXPORT___;
